import React from "react";

const RadioButtonsDps = ({ register, setDps, setChecked, name, id, disabled=false }) => {

  const handle = (e) => {
    setDps(e.target.value === "true");
    if (e.target.value === "true") {
      setChecked(false);
    }
  };

  return (
    <div className="wapperRadioButton">
      <div className="wapperRadioButton__dolar">
        <label htmlFor={`success_dps_${id}`}>
          <input
            type="radio"
            name={name}
            id={`success_dps_${id}`}
            value={true}
            onChange={handle}
            disabled={disabled}
            ref={register}
          />
          <span>Si</span>
        </label>
      </div>
      <div className="wapperRadioButton__soles">
        <label htmlFor={`denied_dps_${id}`}>
          <input
            type="radio"
            name={name}
            id={`denied_dps_${id}`}
            value={false}
            onChange={handle}
            disabled={disabled}
            ref={register}
            defaultChecked
          />
          <span>No</span>
        </label>
      </div>
    </div>
  );
};

export default RadioButtonsDps;
